{
  "formation_requests": {
    "sidebar_link": "Nueva solicitud de la organización",
    "accept_success": "La solicitud de la organización fue aceptada.",
    "reject_success": "La solicitud de la organización fue rechazada.",
    "form_title": "Nueva solicitud de la organización",
    "view_title": "Consultar la solicitud de la organización",
    "list_title": "Lista de solicitudes de la organización",
    "list_link": "Lista de todas las solicitudes",
    "new_link": "Nueva solicitud",
    "send_request": "Enviar solicitud",
    "create_formation_request": "Solicitud de la organización",
    "go_to_index": "Regresar a las organizaciones",
    "empty_list": "No hay solicitudes de la organización"
  }
}
